import { useMutation, useQueryClient } from '@tanstack/react-query'

import { GroupService } from '@/services/group'
import { useNotify } from '@/hooks'
import { CreateAccountRequest } from '@/models/account'

const useCreateGroupAccount = ({ groupId, onSuccess }: { groupId: string; onSuccess?(): void }) => {
  const { notifyError, notifySuccess } = useNotify()
  const queryClient = useQueryClient()

  const create = async (data: CreateAccountRequest) => {
    const result = await GroupService.createGroupAccount(groupId, data)
    return result.data
  }

  const { mutate: createAccount, isPending: isCreating } = useMutation({
    mutationFn: create,
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: ['group-accounts', groupId] })
      await queryClient.refetchQueries({ queryKey: ['group', groupId] })
      notifySuccess('Account created successfully')
      onSuccess?.()
    },
    onError: (error) => {
      notifyError(error.message ?? 'There was an error')
    },
  })

  return { createAccount, isCreating }
}

export { useCreateGroupAccount }
